const NewChevronRight = ({size = 16, fillColor = '#E82026'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none">
    <path
      fill={fillColor}
      d="m11.53 8.53-5 5a.751.751 0 0 1-1.062-1.062L9.938 8 5.468 3.53a.751.751 0 1 1 1.063-1.062l5 5a.748.748 0 0 1-.001 1.063Z"
    />
  </svg>
);
export default NewChevronRight;
